import { render, staticRenderFns } from "./crudSensorsNotifications.vue?vue&type=template&id=65f15ed8"
import script from "./crudSensorsNotifications.vue?vue&type=script&lang=js"
export * from "./crudSensorsNotifications.vue?vue&type=script&lang=js"
import style0 from "./crudSensorsNotifications.vue?vue&type=style&index=0&id=65f15ed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports